
export default {
  UPDATE_TRIPS_MONITOR ( state, payload){
    state.trips = payload
  },
  UPDATE_TRIPS ( state, trips){
    state.trips = trips
  },
  SET_TRIP_DETAILS( state, trip){
    state.trip = trip
  },
  SET_CURRENT_PAGE(state, payload) {
    state.currentPage = payload
  },
  SET_FILTERS(state, payload){
    state.filters = payload;
  }
}
